import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  ADDRESS,
  CITY,
  COMPANY_NAME,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";

const finalDestinationField = fieldName => `final_destination_${fieldName}`;

export default function FinalDestinationDetails({ record }) {
  const finalDestinationAddress = record.get(finalDestinationField(ADDRESS));

  return (
    <div>
      <h3 style={{ marginTop: 10 }}>Final Destination</h3>
      <table className="table table-condensed">
        <tbody>
          {finalDestinationAddress && (
            <Fragment>
              <tr>
                <th className="text-right">Company Name</th>
                <td>{record.get(finalDestinationField(COMPANY_NAME))}</td>
              </tr>
              <tr>
                <th className="text-right">Address Line</th>
                <td>
                  {finalDestinationAddress.get(LINE1)}
                  {finalDestinationAddress.get(LINE2) && <br />}
                  {finalDestinationAddress.get(LINE2) &&
                    finalDestinationAddress.get(LINE2)}
                </td>
              </tr>
              <tr>
                <th className="text-right">City</th>
                <td>{finalDestinationAddress.get(CITY)}</td>
              </tr>
              <tr>
                <th className="text-right">State/ Province/ Region</th>
                <td>{finalDestinationAddress.get(STATE)}</td>
              </tr>
              <tr>
                <th className="text-right">ZIP/ Postal Code</th>
                <td>{finalDestinationAddress.get(POSTAL_CODE)}</td>
              </tr>
              <tr>
                <th className="text-right">Country</th>
                <td>{finalDestinationAddress.get(COUNTRY)}</td>
              </tr>
            </Fragment>
          )}
          <tr>
            <th className="text-right">Contact Name</th>
            <td>{record.get(finalDestinationField("name"))}</td>
          </tr>
          <tr>
            <th className="text-right">Contact Phone</th>
            <td>{record.get(finalDestinationField("phone"))}</td>
          </tr>
          <tr>
            <th className="text-right">Contact Email</th>
            <td>{record.get(finalDestinationField("email"))}</td>
          </tr>
          <tr>
            <th className="text-right">Ref#</th>
            <td>{record.get(finalDestinationField("reference"))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

FinalDestinationDetails.propTypes = {
  record: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/FinalDestination/FinalDestinationDetails.jsx